import { useEffect, useState } from "react";

export default function useAlphabetical<T>(list: T[], compareField: string) {
    const [sortedList, setSortedList] = useState([]);

    useEffect(() => {
        try {
            if (list && Array.isArray(list)) {
                setSortedList(list.sort(
                    (a, b) => a[compareField].localeCompare(b[compareField])
                ));
            } else {
                setSortedList([]);
            }
        } catch (err) {
            console.error(err);
            setSortedList([]);
        }
    }, [list]);

    return sortedList;
}